import 'twin.macro'

import { Button } from 'components/UI/button/button'
import SubTitle from 'components/UI/sub-title/sub-title'
import Title from 'components/UI/title/title'
import { ThemeContext } from 'contexts/theme-context'
import { useDeviceInfo } from 'hooks/useDeviceInfo'
import React, { useContext, useEffect, useMemo, useState } from 'react'
import { Trans, useTranslation } from 'react-i18next'
import tw from 'twin.macro'

import AuthModal from '../auth-modal'
import BannerImg from './../../../assets/images/banner-img_3x.webp'
import BannerImgDark from './../../../assets/images/banner-img-dark.webp'
import MobileBannerImg from './../../../assets/images/mobile-banner-img.webp'
import MobileBannerImgDark from './../../../assets/images/mobile-banner-img-dark.webp'

function Banner() {
  const [activeImg, setActiveImg] = useState<any>(null)
  const [open, setOpen] = useState<boolean>(false)
  const { isMobile } = useDeviceInfo()
  const { theme } = useContext(ThemeContext)
  const { t } = useTranslation()

  const handleClose = () => {
    setOpen(false)
  }

  return (
    <>
      <div tw='w-full bg-secondary rounded-s32 flex flex-col overflow-hidden relative sm:h-[761px] h-[520px] mt-4'>
        <div tw='relative sm:top-32 top-20 sm:z-20 max-w-max mx-auto text-center'>
          <p tw='sm:text-[48px] text-[32px] font-bold sm:mb-4 mb-2'>
            <Trans>{t('banner.title', { ns: 'landing' })}</Trans>
          </p>
          <SubTitle twStyle={tw`text-secondary sm:max-w-[500px] max-w-[300px]`}>
            {t('banner.desc', { ns: 'landing' })}
          </SubTitle>
          <Button
            variant='gradient'
            onClick={() => setOpen(true)}
            twStyle={tw`sm:mt-10 mt-5 max-w-[297px] relative z-10`}
          >
            {t('banner.button_text', { ns: 'landing' })}
          </Button>
        </div>
        {isMobile ? (
          <>
            <img
              src={MobileBannerImgDark}
              alt='banner'
              tw='absolute bottom-0 opacity-0'
              css={theme === 'dark' && tw`opacity-100`}
            />
            <img
              src={MobileBannerImg}
              alt='banner'
              tw='absolute bottom-0 opacity-0'
              css={theme === 'light' && tw`opacity-100`}
            />
          </>
        ) : (
          <>
            <img
              src={BannerImgDark}
              alt='banner'
              tw='absolute bottom-0 opacity-0'
              css={theme === 'dark' && tw`opacity-100`}
            />
            <img
              src={BannerImg}
              alt='banner'
              tw='absolute bottom-0 opacity-0'
              css={theme === 'light' && tw`opacity-100`}
            />
          </>
        )}
      </div>
      <AuthModal channel='auth' open={open} onClose={handleClose} />
    </>
  )
}

export default Banner
